var _excluded = ["status"],
    _excluded2 = ["className", "icon", "iconProps"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Icon } from '@chakra-ui/icon';
import { createContext } from '@chakra-ui/react-utils';
import { chakra, forwardRef, omitThemingProps, StylesProvider, useMultiStyleConfig, useStyles } from '@chakra-ui/system';
import { cx } from '@chakra-ui/utils';
import * as React from 'react';
import { CheckIcon, ErrorIcon, WarningIcon } from './icons';
var STATUSES = {
  default: {
    ic: ErrorIcon,
    color: 'gray.200'
  },
  info: {
    ic: ErrorIcon,
    color: 'brand.500'
  },
  warning: {
    ic: ErrorIcon,
    color: 'orange.500'
  },
  warningSecondary: {
    ic: WarningIcon,
    color: 'orange.500'
  },
  success: {
    ic: CheckIcon,
    color: 'green.500'
  },
  error: {
    ic: ErrorIcon,
    color: 'red.500'
  },
  errorSecondary: {
    ic: WarningIcon,
    color: 'red.500'
  }
};
var [AlertProvider, useAlertContext] = createContext({
  name: 'AlertContext',
  errorMessage: // eslint-disable-next-line max-len
  'useAlertContext: `context` is undefined. Seems you forgot to wrap alert components in `<Alert />`'
});

/**
 * Alert is used to communicate the state or status of a
 * page, feature or action
 */
export var Alert = forwardRef((props, ref) => {
  var _props$color, _props$variant;

  var _omitThemingProps = omitThemingProps(props),
      {
    status = 'info'
  } = _omitThemingProps,
      rest = _objectWithoutPropertiesLoose(_omitThemingProps, _excluded);

  var color = (_props$color = props.color) != null ? _props$color : STATUSES[status].color;
  var variant = (_props$variant = props.variant) != null ? _props$variant : 'subtle';
  var styles = useMultiStyleConfig('Alert', _extends({}, props, {
    color
  }));
  return /*#__PURE__*/React.createElement(AlertProvider, {
    value: {
      status,
      variant
    }
  }, /*#__PURE__*/React.createElement(StylesProvider, {
    value: styles
  }, /*#__PURE__*/React.createElement(chakra.div, _extends({
    ref: ref,
    role: "alert"
  }, rest, {
    __css: styles.container,
    className: cx('chakra-alert', props.className)
  }))));
});
export var AlertTitle = forwardRef((props, ref) => {
  var styles = useStyles();
  return /*#__PURE__*/React.createElement(chakra.div, _extends({
    ref: ref
  }, props, {
    __css: styles.title,
    className: cx('chakra-alert__title', props.className)
  }));
});
export var AlertDescription = forwardRef((props, ref) => {
  var styles = useStyles();

  var descriptionStyles = _extends({
    display: 'inline'
  }, styles.description);

  return /*#__PURE__*/React.createElement(chakra.div, _extends({
    ref: ref
  }, props, {
    __css: descriptionStyles,
    className: cx('chakra-alert__desc', props.className)
  }));
});
export var AlertIcon = props => {
  var {
    status,
    variant
  } = useAlertContext();

  var {
    icon,
    iconProps
  } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded2);

  var {
    ic: BaseIcon
  } = STATUSES[status];
  var styles = useStyles();
  var vlf = variant === 'left-filled';
  var iconColor = (iconProps == null ? void 0 : iconProps.color) || (vlf ? 'white' : 'inherit');
  return /*#__PURE__*/React.createElement(chakra.span, _extends({
    display: "inherit"
  }, rest, {
    __css: styles.icon,
    className: cx('chakra-alert__icon', props.className)
  }), icon ? /*#__PURE__*/React.createElement(Icon, _extends({
    as: icon,
    h: "100%",
    sx: {
      color: iconColor
    },
    w: "100%"
  }, iconProps)) : /*#__PURE__*/React.createElement(BaseIcon, {
    h: "100%",
    w: "100%"
  }));
};
//# sourceMappingURL=alert.js.map